import { NcIconMagnify, NcInput } from "@noted/noted-components";
import { KeyboardEvent } from "react";
import { useDebouncedCallback } from "use-debounce";

import { useI18n } from "~/hooks/use-i18n";

interface SearchBoxProps {
  id: string;
  labelKey?: string;
  defaultValue?: string;
  onChange: (term: string) => void;
  onKeyboardNavOut?: (event: KeyboardEvent) => void;
}

const SearchBox = ({ id, labelKey, defaultValue, onChange, onKeyboardNavOut }: SearchBoxProps) => {
  const { t } = useI18n("org");

  const label = labelKey ? t(labelKey) : t("search");

  const searchKey = defaultValue || "";
  const debounced = useDebouncedCallback(value => {
    onChange(value);
  }, 900);

  const onKeyboardNav = (event: KeyboardEvent) => {
    if (event.key === "ArrowDown") {
      onKeyboardNavOut?.(event);
    }
  };

  return (
    <div className="search-box">
      <div className="relative w-full">
        <label htmlFor={id} className="sr-only">
          {label}
        </label>
        <NcIconMagnify
          className="text-disabled pointer-events-none absolute top-2.5 left-3 z-2"
          opacity={0.5}
        />
        <NcInput
          inputWidth="full"
          id={id}
          className="z-0 pl-9"
          aria-label={label}
          placeholder={label}
          defaultValue={searchKey}
          onChange={e => debounced(e.target.value)}
          onKeyUp={onKeyboardNav}
        />
      </div>
    </div>
  );
};

export default SearchBox;
